import { render, staticRenderFns } from "./Vidello.vue?vue&type=template&id=3c552d24&scoped=true&"
import script from "./Vidello.vue?vue&type=script&lang=js&"
export * from "./Vidello.vue?vue&type=script&lang=js&"
import style0 from "./Vidello.vue?vue&type=style&index=0&id=3c552d24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c552d24",
  null
  
)

export default component.exports